import React from "react";
import { KpiCardData } from "../../types";

interface DashboardKpiRowProps {
  cards: KpiCardData[];
  onCardClick?: (index: number) => void;
}

const DashboardKpiRow: React.FC<DashboardKpiRowProps> = ({
  cards,
  onCardClick,
}) => {
  const displayText = (text?: string) =>
    text && text.trim() !== "-" ? text : null;

  return (
    <div className="partner-dashboard-kpi-row">
      {cards.map((card, index) => {
        const value = displayText(card.value);
        const label = displayText(card.label);
        const subtext = displayText(card.subtext);

        // When there is no primary value (e.g. no active contract), promote the
        // label into the top value slot so the card still has a clear headline.
        const showLabelAsValue = !value && !!label && !subtext;
        const topValue = value || (showLabelAsValue ? label : null);
        const footerLabel = showLabelAsValue ? null : label;
        const isClickable = Boolean(onCardClick);

        return (
          <div
            key={card.label || `kpi-${index}`}
            className={`partner-dashboard-kpi-card${
              isClickable ? " partner-dashboard-kpi-card--clickable" : ""
            }`}
            role={isClickable ? "button" : undefined}
            tabIndex={isClickable ? 0 : undefined}
            onClick={isClickable ? () => onCardClick?.(index) : undefined}
            onKeyDown={
              isClickable
                ? (event) => {
                    if (event.key === "Enter" || event.key === " ") {
                      event.preventDefault();
                      onCardClick?.(index);
                    }
                  }
                : undefined
            }
          >
            {topValue ? (
              <div className="partner-dashboard-kpi-card__value">{topValue}</div>
            ) : null}
            {(footerLabel || subtext) && (
              <div className="partner-dashboard-kpi-card__footer">
                {footerLabel ? (
                  <div className="partner-dashboard-kpi-card__label">
                    {footerLabel}
                  </div>
                ) : (
                  <span />
                )}
                {subtext ? (
                  <div className="partner-dashboard-kpi-card__subtext">
                    {subtext}
                  </div>
                ) : null}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default DashboardKpiRow;
